(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hk-coffee-relation-buy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-hk-relation-variant]')) return;
    const form = event.target.closest('form');
    const button = form && form.querySelector('button[name="add"]');
    if (button) button.disabled = !event.target.value;
  });
  } catch(e) { console.error(e); }
})();

})();
